<template>
  <div class="inspect-container">
    <CardBox
      title="巡检统计"
      subtitle="Inspection statistics"
      :contentStyle="{ 'padding-top': '5px' }"
    >
      <!-- 总巡检数 & 总完成率 -->
      <div class="inspect-total">
        <img class="inspect-total__bg" src="@/assets/image/homeIndex/inspect_total_bg.png" alt="" />
        <div class="inspect-total__content">
          <div class="inspect-total__info">
            <span class="inspect-total__label">总巡检数</span>
            <span class="inspect-total__value">{{ statData.total }}</span>
          </div>
          <div class="inspect-total__info">
            <span class="inspect-total__label">总完成率</span>
            <span class="inspect-total__value">{{ statData.totalCompleteRate }}%</span>
          </div>
        </div>
      </div>

      <!-- 四项指标 -->
      <div class="inspect-grid">
        <div class="inspect-item">
          <img class="inspect-item__bg" src="@/assets/image/homeIndex/inspect_item_bg.png" alt="" />
          <div class="inspect-item__content">
            <img
              class="inspect-item__icon"
              src="@/assets/image/homeIndex/icon_inspect_month.png"
              alt="本月总数"
            />
            <div class="inspect-item__info">
              <span class="inspect-item__label">本月总数</span>
              <span class="inspect-item__value">{{ statData.curMonthCount }}</span>
            </div>
          </div>
        </div>

        <div class="inspect-item">
          <img class="inspect-item__bg" src="@/assets/image/homeIndex/inspect_item_bg.png" alt="" />
          <div class="inspect-item__content">
            <img
              class="inspect-item__icon"
              src="@/assets/image/homeIndex/icon_inspect_completed.png"
              alt="已完成"
            />
            <div class="inspect-item__info">
              <span class="inspect-item__label">已完成</span>
              <span class="inspect-item__value">{{ statData.curMonthCompleteCount }}</span>
            </div>
          </div>
        </div>

        <div class="inspect-item">
          <img class="inspect-item__bg" src="@/assets/image/homeIndex/inspect_item_bg.png" alt="" />
          <div class="inspect-item__content">
            <img
              class="inspect-item__icon"
              src="@/assets/image/homeIndex/icon_inspect_overdue.png"
              alt="超期完成"
            />
            <div class="inspect-item__info">
              <span class="inspect-item__label">超期完成</span>
              <span class="inspect-item__value inspect-item__value--warn">{{
                statData.curMonthTimeoutCount
              }}</span>
            </div>
          </div>
        </div>

        <div class="inspect-item">
          <img class="inspect-item__bg" src="@/assets/image/homeIndex/inspect_item_bg.png" alt="" />
          <div class="inspect-item__content">
            <img
              class="inspect-item__icon"
              src="@/assets/image/homeIndex/icon_inspect_rate.png"
              alt="完成率"
            />
            <div class="inspect-item__info">
              <span class="inspect-item__label">合格率</span>
              <span class="inspect-item__value">{{ statData.curMonthPassRate }}%</span>
            </div>
          </div>
        </div>
      </div>
    </CardBox>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import CardBox from './cardBox.vue'

export default {
  name: 'InspectStatisticsComponent',
  components: { CardBox },
  setup() {
    const store = useStore()
    const statData = reactive({
      total: 0,
      totalCompleteRate: '0',
      curMonthCount: 0,
      curMonthCompleteCount: 0,
      curMonthTimeoutCount: 0,
      curMonthPassRate: '0'
    })

    const hideGearIcon = e => {
      e.target.style.display = 'none'
    }

    const fetchData = async () => {
      try {
        const res = await store.dispatch('fetchGetIndexInspectTaskCount')
        if (res && res.data) {
          Object.assign(statData, res.data)
        }
      } catch (e) {
        console.error('获取巡检统计数据失败', e)
      }
    }

    // 供父组件调用的定时刷新方法
    const refreshData = () => {
      fetchData()
    }

    onMounted(() => {
      fetchData()
    })

    return {
      statData,
      hideGearIcon,
      refreshData
    }
  }
}
</script>

<style lang="scss" scoped>
.inspect-container {
  width: 100%;
  height: 293px;
  margin-bottom: 20px;
}

.inspect-total {
  position: relative;
  width: 100%;
  height: 91px;
  margin-bottom: 5px;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }

  &__info {
    width: 154px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 4px;
  }

  &__label {
    font-size: 16px;
    color: #b8d4f0;
    letter-spacing: 1px;
    font-family: 'SourceHanSansCN-Medium';
  }

  &__value {
    font-size: 18px;
    font-weight: 700;
    font-family: 'OPPOSans-B';
    line-height: 20px;
    text-align: center;
    background: linear-gradient(180deg, #ffffff 40%, #00ffff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25));
  }

  &__center {
    width: 60px;
    height: 91px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__gear-icon {
    width: 50px;
    height: auto;
    object-fit: contain;
  }
}

.inspect-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.inspect-item {
  position: relative;
  width: 195px;
  height: 71px;
  border-radius: 6px;
  padding-left: 24px;
  box-sizing: border-box;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    gap: 16px;
  }

  &__icon {
    width: 48px;
    height: 56px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    font-size: 14px;
    color: #D5EAFF;
    letter-spacing: 1px;
    font-family: 'SourceHanSansCN-Regular';
  }

  &__value {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    font-family: 'OPPOSans-M';

    &--warn {
      color: #ff8c00;
    }
  }
}
</style>
